module.exports = __webpack_public_path__ + "assets/img/box2-img.edca1bce.png";